<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" temporary fixed>
      <v-list>
        <v-list-group prepend-icon="home" value="true">
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>Mon espace</v-list-tile-title>
            </v-list-tile>
          </template>
          <v-list-tile>
            <v-autocomplete
              @change="changePlayer()"
              v-model="player_id"
              :items="players"
              item-text="name"
              item-value="id"
            ></v-autocomplete>
          </v-list-tile>

          <v-list-tile @click="goToMyRecommendations()">
            <v-list-tile-title>Mes recommandations</v-list-tile-title>
          </v-list-tile>

          <v-list-tile @click="goToKillList()">
            <v-list-tile-title>Ma kill list</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="goToHistory()">
            <v-list-tile-title>Mes scores</v-list-tile-title>
          </v-list-tile>

          <v-list-tile @click="goToMyGames()">
            <v-list-tile-title>Mes jeux</v-list-tile-title>
          </v-list-tile>

          <v-list-tile @click="goToMyPlatforms()">
            <v-list-tile-title>Mes plateformes</v-list-tile-title>
          </v-list-tile>
        </v-list-group>

        <v-list-group prepend-icon="search" value="true">
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>Explorer</v-list-tile-title>
            </v-list-tile>
          </template>
          <v-list-tile @click="goToGames()">
            <v-list-tile-title>Tous les jeux</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="goToPlatforms()">
            <v-list-tile-title>Toutes les plateformes</v-list-tile-title>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar app>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title class="headline text-uppercase">
        <span>shmup</span>
        <span class="font-weight-light">COMPANION</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn flat href="http://hiscores.shmup.com" target="_blank" class="hidden-sm-and-down">
        <span class="mr-2">Hiscores</span>
        <v-icon>open_in_new</v-icon>
      </v-btn>
    </v-toolbar>

    <v-content>
      <Loader :show="loading"></Loader>
      <v-container fluid grid-list-lg>
        <router-view/>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import axios from 'axios';
  import api from '@/api';
  import Loader from '@/components/atoms/Loader.vue';

  export default {
    name: 'App',
    components: { Loader },
    data() {
      return {
        drawer: null,
        players: null,
        loading: true,
      };
    },
    computed: {
      player_id: {
        get: function () {
          return this.$store.state.playerId;
        },
        set: function (player_id) {
          this.$store.dispatch('setPlayerId', player_id);
        },
      },
    },
    mounted() {
      axios
        .get(`${api.endpoint}/players`)
        .then(response => (this.players = response.data))
        .then(() => (this.loading = false));
    },
    methods: {
      goToKillList() {
        this.$router.push({ name: 'kill-list' });
      },
      goToMyPlatforms() {
        this.$router.push({ name: 'my-platforms', params: { id: this.player_id } });
      },
      goToMyGames() {
        this.$router.push({ name: 'my-games', params: { id: this.player_id } });
      },
      goToMyRecommendations() {
        this.$router.push({ name: 'my-recommendations', params: { id: this.player_id } });
      },
      goToPlatforms() {
        this.$router.push({ name: 'platforms' });
      },
      goToGames() {
        this.$router.push({ name: 'games' });
      },
      goToHistory() {
        this.$router.push({ name: 'history' });
      },
      changePlayer() {
        const dispatches = {
          'history': 'fetchHistory',
          'kill-list': 'fetchKillList',
          'my-platforms': 'fetchMyPlatforms',
          'my-recommandations': 'fetchMyRecommendations',
          'my-games': 'fetchMyGames',
        };
        this.loading = true;
        this.$store.dispatch('setPlayerId', this.player_id)
          .then(() => {
            if (dispatches[this.$route.name]) {
              return this.$store.dispatch(dispatches[this.$route.name]);
            }
          })
          .then(() => (this.loading = false));
      },
    },
  };
</script>
